"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var useAppContext_1 = require("../../../common/react/useAppContext");
var useWidgetContext_1 = require("../../../common/react/useWidgetContext");
var GoHomeButton_1 = require("../GoHomeButton/GoHomeButton");
var MySummaryExpanded_1 = require("../mySummaryExpanded/MySummaryExpanded");
var ConfirmationMainContentStyles_1 = require("./ConfirmationMainContentStyles");
var ConfirmationMainContent = function (_a) {
    var children = _a.children;
    var homePageURL = useWidgetContext_1.default().configuration.homePageURL;
    var style = ConfirmationMainContentStyles_1.default({
        marginSize: homePageURL ? 0 : 4,
    });
    var deal = useAppContext_1.default().deal;
    return (<core_1.Container>
      <core_1.Box className={style.confirmationWrapper}>
        <core_1.Box className={style.mainContent}>{children}</core_1.Box>
      </core_1.Box>
      {homePageURL && <GoHomeButton_1.default homePageURL={homePageURL}/>}
      <core_1.Box className={style.summaryWrapper}>{deal && <MySummaryExpanded_1.default />}</core_1.Box>
    </core_1.Container>);
};
exports.default = ConfirmationMainContent;
